import { Card as MuiCard } from '@mui/material';
import styled from 'styled-components';
import PlaysDashboardToggle from './PlaysDashboardToggle';

export const Toggle = styled(PlaysDashboardToggle)`
  padding: 16px 0;
`;

export const Card = styled(MuiCard)`
  margin: 16px 0;
`;
